import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 20px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }

  span {
    color: #f16024;
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  max-width: 1369px;
  margin: 80px auto 0 auto;
  padding: 70px 20px 10px 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    max-width: 340px;
    gap: 10px;

    padding: 0;
    margin: 24px auto 0;
  }

  > p {
    grid-column: 1 / -1;
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    padding: 0 300px 40px 100px;
    margin-bottom: 40px;

    @media (max-width: 768px) {
      padding: 0 20px 0 0;
      margin-bottom: 20px;
    }

    span {
      color: #f16024;
    }
  }
`;

export const TextBox1 = styled.div`
  p {
    color: #e4e4e4;
    font-family: 'Barlow';
    font-size: 32px;
    font-style: normal;
    font-weight: 300;
    line-height: 40px;
    padding: 30px 100px 0 100px;
    margin: 0;

    @media (max-width: 768px) {
      padding: 0 0 20px 0;
      font-family: 'Open Sans';
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }
  }
`;

export const TextBox2 = styled.div`
  display: grid;
  grid-template-columns: minmax(50%, 50%) 1fr;
  gap: 20px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  h2 {
    font-family: 'Barlow';
    font-family: Barlow;
    font-size: 22px;
    font-style: normal;
    font-weight: 275;
    line-height: 24px;
    padding-bottom: 10px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  p {
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    color: #c3c3c3;
  }

  ul {
    margin-left: 30px;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    color: #c3c3c3;
  }

  .grid-content {
    padding: 40px;

    &:hover {
      background-color: #171717;
    }

    @media (max-width: 768px) {
      padding: 0 20px 20px 0;

      &:hover {
        background-color: transparent;
      }
    }

    span {
      color: #f16024;
    }
  }
`;
